import { render } from "./transfer_funds_modal.vue?vue&type=template&id=ba8d835a&scoped=true"
import script from "./transfer_funds_modal.vue?vue&type=script&lang=js"
export * from "./transfer_funds_modal.vue?vue&type=script&lang=js"

import "./transfer_funds_modal.vue?vue&type=style&index=0&id=ba8d835a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8d835a"]])

export default __exports__